import {
  Table,
  TableBody,
  TableHead,
  TableFooter,
  Typography,
} from '@mui/material';
import React from 'react';
import {
  StyledBodyCell,
  StyledHeadCell,
  StyledTableRow,
  StyledFooterCell,
  StyledSkeleton,
} from '../components';

export function LoadingUnpaidFixedAssetsTable() {
  return (
    <Table sx={{borderCollapse: 'separate'}}>
      <TableHead>
        <StyledTableRow sx={{border: '0 !important'}}>
          <StyledHeadCell>
            <Typography>Internal ID</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Account Name</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Bill Posting Period</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Period Closed</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Type</Typography>
          </StyledHeadCell>
          <StyledHeadCell>
            <Typography>Amount</Typography>
          </StyledHeadCell>
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {Array.from({length: 5}).map((_, idx) => (
          <StyledTableRow key={`tablebodyrow-${idx}`}>
            {Array.from({length: 6}).map((_, idx) => (
              <StyledBodyCell key={`body1-${idx}`}>
                <StyledSkeleton />
              </StyledBodyCell>
            ))}
          </StyledTableRow>
        ))}
      </TableBody>
      <TableFooter>
        <StyledTableRow>
          <StyledFooterCell colSpan={5} />
          <StyledFooterCell>
            <StyledSkeleton />
          </StyledFooterCell>
        </StyledTableRow>
      </TableFooter>
    </Table>
  );
}
